import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';

import { ConfirmationDialogComponent } from '../components/confirmation-dialog/confirmation-dialog.component';
import { ConfirmDialog } from '../components/confirmation-dialog/interfaces/confirmation';
@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  public currentUser = new Subject<any>();

  constructor(  public dialog: MatDialog, private _snackBar: MatSnackBar){
  }

  success(text: string) {
    this._snackBar.open(text, 'Ok', {
      duration: 1500,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['snackbar-success'],
    });
  }

  error(text: string) {
    this._snackBar.open(text, 'Ok', {
      duration: 10000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['snackbar-error'],
    });
  }


  public openDialog(data: ConfirmDialog) {
    this.dialog.open(ConfirmationDialogComponent, {
      data,
    }).afterClosed().subscribe((res: any) => {
      if (res) {
        // Handle password field result
        if (data.showPasswordField && res.confirmed && res.password) {
          data.onConfirm?.(res.password);
        } else if (!data.showPasswordField && res === true) {
          // Handle regular confirmation (no password)
          data.onConfirm?.();
        }
      } else {
        if(data.onCancel) {
          data.onCancel();
        }
      }
    });
  }
}
